import "@diligentcorp/atlas-web-component-icons/lib/expand-down/index.js";
import "@diligentcorp/atlas-web-component-icons/lib/expand-right/index.js";
import { css, html, LitElement } from "lit";
import { when } from "lit/directives/when.js";
import { defineComponent } from "../../configuration/utils.js";
import { appSwitcherItem, navVar } from "../styles.js";
import { NavTreeNode } from "./NavTreeNode.js";
const listItemVar = (name) => navVar(`list-item-${name}`);
export class NavTree extends LitElement {
    constructor() {
        super();
        this.handleClick = (e) => {
            e.preventDefault();
            this.isOpen = !this.isOpen;
        };
        this.level = 0;
        this.label = "";
        this.isOpen = false;
        this.isCurrent = false;
    }
    updated() {
        this.subTrees.forEach((tree) => {
            tree.level = this.level + 1;
        });
    }
    render() {
        return html `
      <details ?open=${this.isOpen}>
        <summary class="item" @click=${this.handleClick}>
          <span class="icon">
            ${when(this.isOpen, () => html `<dil-expand-down-icon aria-hidden="true"></dil-expand-down-icon>`, () => html `<dil-expand-right-icon aria-hidden="true"></dil-expand-right-icon>`)}
          </span>
          <span class="label">${this.label}</span>
        </summary>
      </details>
      ${when(this.isOpen, () => html `
          <ul>
            <slot></slot>
          </ul>
        `)}
    `;
    }
    get subTrees() {
        const slot = this.shadowRoot?.querySelector("slot");
        if (!slot) {
            return [];
        }
        return slot
            .assignedElements()
            .filter((node) => node instanceof NavTree || node instanceof NavTreeNode);
    }
}
NavTree.properties = {
    label: { type: String, reflect: true, attribute: true },
    isOpen: { type: Boolean, reflect: true, attribute: "is-open" },
    isCurrent: { type: Boolean, reflect: true, attribute: "is-current" },
    level: { type: Number, reflect: true },
};
NavTree.styles = [
    appSwitcherItem,
    css `
      :host {
        --extra-padding: 0.25rem;
      }
      :host([level="0"]) {
        padding: var(--extra-padding, 0);
        --depth: 1;
      }
      :host([level="0"]) summary.item {
        --item-left-padding: calc(${listItemVar("padding")} - var(--extra-padding, 0));
      }
      :host([level="1"]) summary.item {
        --item-left-padding: calc(2 * ${listItemVar("padding")} - var(--extra-padding, 0));
      }
      :host([level="2"]) summary.item {
        --item-left-padding: calc(3 * ${listItemVar("padding")} - var(--extra-padding, 0));
      }
      :host([level="3"]) summary.item {
        --item-left-padding: calc(4 * ${listItemVar("padding")} - var(--extra-padding, 0));
      }
      :host([level="4"]) summary.item {
        --item-left-padding: calc(5 * ${listItemVar("padding")} - var(--extra-padding, 0));
      }

      summary.item {
        padding-left: var(--item-left-padding, ${listItemVar("padding")});
        padding-right: ${listItemVar("padding")};
        padding-top: calc(${listItemVar("padding")} / 2);
        padding-bottom: calc(${listItemVar("padding")} / 2);
        font-size: calc(${listItemVar("font-size")} - 0.1rem);
      }
      summary::-webkit-details-marker {
        display: none;
      }
      ul {
        margin-top: calc(${navVar("list-gap")} / 2);
        margin-bottom: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        gap: calc(${navVar("list-gap")} / 2);
      }
    `,
];
export const NAV_TREE_TAG = "atlas-gn-nav-tree";
defineComponent(NAV_TREE_TAG, NavTree);
